module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment"
  }, [_c('h1', [_vm._v("Joey Haddad - 2019 / 2020 Season")]), _vm._v(" "), _c('p', [_vm._v(" All Situations - Goals SOT Shifts")]), _vm._v(" "), _c('p', [_vm._v(" EH - Shot+/-")]), _vm._v(" "), _c('apex-chart', {
    ref: "test",
    attrs: {
      "type": "line",
      "height": "350",
      "series": _vm.chartData,
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76e32ad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/apex-realtime.vue
// module id = 637
// module chunks = 30